import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import styled from 'styled-components';
import { variant } from 'styled-system';
import { Box } from '../Box/index.js';

const StyledText = styled(Box).withConfig({
  displayName: "Text__StyledText",
  componentId: "sc-s2v5py-0"
})(["", ";"], variant({
  prop: 'fontSizeFormat',
  variants: {
    fontSize0: {
      fontSize: 'fontSize0',
      lineHeight: 'lineHeight0'
    },
    fontSize10: {
      fontSize: 'fontSize10',
      lineHeight: 'lineHeight10'
    },
    fontSize20: {
      fontSize: 'fontSize20',
      lineHeight: 'lineHeight20'
    },
    fontSize30: {
      fontSize: 'fontSize30',
      lineHeight: 'lineHeight30'
    },
    fontSize40: {
      fontSize: 'fontSize40',
      lineHeight: 'lineHeight40'
    },
    fontSize50: {
      fontSize: 'fontSize50',
      lineHeight: 'lineHeight50'
    },
    fontSize60: {
      fontSize: 'fontSize60',
      lineHeight: 'lineHeight60'
    },
    fontSize70: {
      fontSize: 'fontSize70',
      lineHeight: 'lineHeight70'
    },
    fontSize80: {
      fontSize: 'fontSize80',
      lineHeight: 'lineHeight80'
    },
    fontSize90: {
      fontSize: 'fontSize90',
      lineHeight: 'lineHeight90'
    }
  }
}));
/**
 * A Text component is used to render text and paragraphs within an interface. It renders a `span` element by default.
 *
 * ### Documentation
 * - [Examples](https://blockparty.endpoint.com/components/text#usage)
 * - [Props](https://blockparty.endpoint.com/components/text#props)
 * <br />
 *
 */
const Text = /*#__PURE__*/forwardRef((_ref, forwardedRef) => {
  let {
    children,
    dataTestId = 'text',
    size = 'fontSize20',
    textStyle,
    ...rest
  } = _ref;
  const truncatedText = {
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  };
  return /*#__PURE__*/React__default.createElement(StyledText, _extends({
    ref: forwardedRef,
    as: "span",
    color: "textPrimary",
    "data-test-id": dataTestId,
    fontSizeFormat: size,
    fontWeight: "normal"
  }, textStyle === 'truncate' && truncatedText, rest), children);
});

export { StyledText, Text };
